export const carsGridStyles = {
  mainBox: { width: "100%", mt: { xs: 5, sm: 7, md: 10 } },
};
